// extracted by mini-css-extract-plugin
module.exports = {"menuRoom":"Rooms_menuRoom__Zzey3","roomName":"Rooms_roomName__2eFfo","lastMessage":"Rooms_lastMessage__gsP9H","timeBox":"Rooms_timeBox__3klQp","time":"Rooms_time__6ieCL"};